// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"3724":"5e815994","4328":"ac119948","5772":"ac119948"}[chunkId] + ".chunk.css";
};